<script>
import statusTable from './log.table.js'
import getExportedFilename from '../../utils/get-exported-filename'
import clientLogDetails from './log-details/client-log-details.vue'
import feedLogDetails from './log-details/feed-log-details.vue'
import merchantLogDetails from './log-details/merchant-log-details.vue'
import offerLogDetails from './log-details/offer-log-details.vue'

export default {
  name: 'Log',
  components: {
    clientLogDetails,
    feedLogDetails,
    merchantLogDetails,
    offerLogDetails,
  },
  page: {
    title: 'Log',
  },
  data() {
    return {
      table: statusTable(this),
    }
  },
  methods: {
    getExportedFilename() {
      return getExportedFilename(this.table.tableName)
    },
  },
}
</script>

<template>
  <main-layout title="Log">
    <table-layout
      hider
      :table-name="table.tableName"
      :processor="table.processor"
      :filters="table.filters"
      :columns="table.columns"
      :fragments="false"
      :quantity="[25, 50, 100, 200]"
      :export-filename="getExportedFilename"
    >
      <template
        slot="expandedRow"
        slot-scope="{ row, columns }"
      >
        <component
          :is="`${row.logType}-log-details`"
          :row="row"
          :columns="columns"
        />
      </template>
    </table-layout>
  </main-layout>
</template>

<style lang="scss" module>
.infoCaption {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  font-weight: bold;

  div {
    margin: 5px 0;
  }
}

.infoValue {
  display: flex;
  flex-direction: column;
  justify-content: center;

  div {
    position: relative;
    z-index: 100;
    margin: 5px 0;
    overflow: visible;
    word-wrap: normal;
    white-space: nowrap;
  }
}
</style>
